webpackJsonp([213534597649335],{

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(79);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_React$Component) {
	  _inherits(Post, _React$Component);
	
	  function Post() {
	    _classCallCheck(this, Post);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Post.prototype.render = function render() {
	    var _props$data$node$fron = this.props.data.node.frontmatter,
	        title = _props$data$node$fron.title,
	        date = _props$data$node$fron.date,
	        category = _props$data$node$fron.category,
	        description = _props$data$node$fron.description;
	    var _props$data$node$fiel = this.props.data.node.fields,
	        slug = _props$data$node$fiel.slug,
	        categorySlug = _props$data$node$fiel.categorySlug;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'post' },
	      _react2.default.createElement(
	        'div',
	        { className: 'post__meta' },
	        _react2.default.createElement(
	          'time',
	          { className: 'post__meta-time', dateTime: (0, _moment2.default)(date).format('MMMM D, YYYY') },
	          (0, _moment2.default)(date).format('MMMM YYYY')
	        ),
	        _react2.default.createElement('span', { className: 'post__meta-divider' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'post__meta-category', key: categorySlug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug, className: 'post__meta-category-link' },
	            category
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'post__title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'post__title-link', to: slug },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'post__description' },
	        description
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'post__readmore', to: slug },
	        'Read'
	      )
	    );
	  };
	
	  return Post;
	}(_react2.default.Component);
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/apple-touch-icon.2a6b054d.png";

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAACTElEQVQ4T62TXUiTYRTH/2fD1VxzzdWmKGzvYFESS/BCIfwARaYMIaEJehXI0iRZ3kUwvBEDFSdIU0kZ0kUIgy68CMSwaCgyYzYvnELqWM4+BqNhtabvE++jkkkXfT13z/mf/+9wnuccwoljMvUUA3InEasmgkmSGcMmYzQL7I9tbt4LHbfQ0aWw8I4yK0vvAaiVCLKT4EOQCLCHmcx7Vyw2+EWKccCB2fCUCBW/Mp6MMYYXmcw7mwThAEHoHSUi5++Yj3IYY2MbG3dvktRzTk72ktF4VpZKpSGXE3Q6FfLyzmBnJ4Vg8C0sFh1UKgVCoTj3l5cLCAZj4u7u1xIyme4/KCo63z4xcR3Z2Qrs7YkIh+NYWdmBw3EFpaXDaGy8jM7Oq6iqGuWA2VknnE4/1tcTXhKE3ggRXZCE7u4aZDIienqeITdXicXF2ygrG4ZafRozM62wWgdRUKDBwIAdDQ0+MMbWyGzuTQOkkABe7zXMz29hcvIVrxQI3EJHxxOYzVr09dlRXz+OurqL2N7+hKmp19IHf/sJMD19A/39zzE394YDfD4H/P4wamstEIRceDwv0dZWhpaWx0in9w4Ax1sIhVxoanqESOQjB7jd1dBqlYhGkzAY1NBoTmF19QOGhgJc5y1IjyiToV0KLC+7YLONIx5P8YTm5mK43TWorByB3X4JXV3lqKgYQSLxmeuiCC//RiL5kjR9Vms+r5ZM8iGDXq+CxXIOgcAW8vPVMBq1WFiIHlaHyNh+yb8P0n8Z5R+Qv1ym4zvwp+v8HXj0ApL9u/6eAAAAAElFTkSuQmCC"

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAFS0lEQVRYR8VXf0zTRxT/HKwtUymOWUWoYhchEzCAik5rpiJxfzSYDQkbmAUcDDZCRJzKCKBG/ijqmD+WYQA3p7CRjCrIHFSUH5FhcJPCxC0IOoIpasZARaa2pdxyV1tLW9Rtmt5f3++9d+993rv3PndH8IzD03OnWCwWKQhBOEBCACoDyFTTcnoHIL0A7aAUDcPDuh+HhnYOP4tp8jQlqTTPTyAQZAKIJQSTnqbP4VDcB1BuMBh2a7W5PU9aMyEAqfTzlwUCXR4hZCMAwbM4dqBjoJQeNBhEuVrt5geObDgEIJUq5wqFqARI0H90bLOMXtbr8Y5Wm3XV1p4dAF9fZairKzkNQPJ8nFusDBiN9K2+vqx2a7vjAJgiJ+dfgHOzzwG9ni6zzoQFANtzoVD38/NL+0T5Y9shWmyuCQsAmUz5GSHkk+ecdofmKKUFvb1ZW5iQA2CtJhQKfvsf1f5vcRv0ekMga1EOQCbLP0wIEhcu9EFwsDcGBkZw754OBoMRLi4EkyYJMW3aZMya5QF/fwlGRnRwdxfh4MEWtLff4M49PNywbdsKeHm5Iz+/ET09g+NAKRSvY8OGRcjJOY2urgHGFV/19n6aRBjDeXi43WQkk5a2FBkZbz4xmtbWPojFbggImIHGxmtISlJxfQa0ufljDkCluoTMzNpxdrZvj0B8/ELs2dOEoqILnKzu3n04k8yZo4x1cSHfMe2wMClyclZjbIxidHQMCxb4cCPMUVfXn7h2bRA1NVeQnLwEmzYt51kKDd3PjPGRl7cGcXGh6Ou7jfDw4nEAGhqS4ev7ChSKr3kG2Bgbo3FEJlOWEEKSbMP29nZHc3Mqn7ZexP6XLfNFael7XCaXf4lbt0b499q1Adi3L5IHEBhYAL3eyOf9/aehtjaRB6FQHLG4opQeJjJZ/i+EYJEtgPnzvVBVFQ9KKUJC9mNkRG9REYtF0GjSQQjB+vXlaG29zmVLl85GWVks/16z5jDPGBvp6cuxcaMcO3bUoazsMQ9RiossA38RQl61BRAR4YeioigMDd1HWNgXtmKcO/cRfHw8kJlZA5Wqk8tzc1cjIcEUS2JiBZqa/uDfZ84kYfr0KZDLC8cFQikdZBkYJQSuth5YwbDC6ei4gXXrSu0AlJSsQ3j4XN4JBw78BFdXgpaWVEgkU7iuOdrAwBmork7A0aMXsWtX/Tg7lMI4IQBzNNXVvyMj4wc7AKzlUlLewIkTndi6tQYrV76GkpJoXLp0EyEh3iguvoDdu5uQnR3Oqz8iogTXr99xBMDxFpgjLCw8j4KCZjsAUVFB2LtXgbY2LWJivkVh4dsQCFyh0fRjy5YVqKvrRlpaFc+KRnMDqamVdjbMW+CwCNXqD+DnJ0FOjhrl5b/aLQ4N9YZK9T4GB/9GZOQ3vCYSEr7nBHXoUBS6uwegVDbiyJEYxMSUoa2t3wEAUxE6bMOOjk3cWHLycdTX2x3jnPna2thdBSgt1WDx4lm8xWQyT5w9+yEePjSgoeEqZs4UIzq6zM45m+BtaE1EZi1CgJ6ebbzNJkLPdFtb0yCRTIbROIbsbDUqKjp5MXZ2boZI9BKfT0+vRm3tFYcAOBFZU7G11smT8QgK8kJ0dKmF722tHDv2LuTyObh9+wFvMZ1ulKucOpWAefNmoL//LlatKoLR+IgqrQxYqJjNmQ8jawezZ0/lbVhe3uFwC5hubGwwb0W1+gqOH79sWZ6SsoTTeGXlZajV3ROk/9FhxKROP45NWXDihcSUBSdfyUwgnHgpNVeKU6/lZhBOfZg8BuHEp5l14zrtcWrLHi/qef4PcU53y2LZnV4AAAAASUVORK5CYII="

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.e20bf7d1.ico";

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Post = __webpack_require__(44);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Sidebar = __webpack_require__(21);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _appleTouchIcon = __webpack_require__(553);
	
	var _appleTouchIcon2 = _interopRequireDefault(_appleTouchIcon);
	
	var _favicon32x = __webpack_require__(555);
	
	var _favicon32x2 = _interopRequireDefault(_favicon32x);
	
	var _favicon16x = __webpack_require__(554);
	
	var _favicon16x2 = _interopRequireDefault(_favicon16x);
	
	var _favicon = __webpack_require__(345);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import siteManifest from '../pages/site.webmanifest';
	
	var IndexRoute = function (_React$Component) {
	  _inherits(IndexRoute, _React$Component);
	
	  function IndexRoute() {
	    _classCallCheck(this, IndexRoute);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexRoute.prototype.render = function render() {
	    var items = [];
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	
	    var posts = this.props.data.allMarkdownRemark.edges;
	    posts.forEach(function (post) {
	      items.push(_react2.default.createElement(_Post2.default, { data: post, key: post.node.fields.slug }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: subtitle }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: _appleTouchIcon2.default }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: _favicon32x2.default }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: _favicon16x2.default }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/x-icon', href: _favicon2.default })
	      ),
	      _react2.default.createElement(_Sidebar2.default, { siteMetadata: this.props.data.site.siteMetadata }),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content__inner' },
	          items
	        )
	      )
	    );
	  };
	
	  return IndexRoute;
	}(_react2.default.Component);
	
	exports.default = IndexRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-c6ead533dd2f579ac233.js